import { setWindow, getWindow, WINDOW_KEYS, setSessionStorage, getSessionStorage, SESSION_STORAGE_KEYS } from "./storage";
import { APPLE_PAY_LABEL, PAYPAL_LABEL, CREDIT_CARD_LABEL } from "./constants";

export const eventDonationFieldInteraction = (event) => {
  let donate = {};
  let data = event.target;

  if (!data) {
    return;
  }

  if (data.id === "other-amount") {
    donate.step = data.parentNode.parentNode.parentNode.querySelector("h2")?.innerText.substring(1, 0);
    donate.amount = parseFloat(data.value.replace("$", "")).toFixed(2);

    donate.field = data.id;
  } else if (data.parentNode.getAttribute("selectorgroup")) {
    donate.field = data.parentNode.getAttribute("selectorgroup");
  } else {
    donate.field = data.id;
  }

  if (data.id !== "other-amount") {
    const target = event.currentTarget.querySelector("h2");
    if (target) {
      donate.step = target.innerText.substring(1, 0);
    }
  }

  if (data.parentNode.getAttribute("selectorgroup") === "frequency") {
    donate.frequency = event.target.innerText;
  }
  if (data.parentNode.getAttribute("selectorgroup") === "amount-selector") {
    donate.amount = parseFloat(event.target.innerText.replace("$", "")).toFixed(2);
  }

  if (data.parentNode.getAttribute("selectorgroup") === "contributor") {
    donate.entity = data.innerText;
  }

  if (data.parentNode.getAttribute("selectorgroup") === "Payment type") {
    donate.paymentType = data.innerText;
  }

  const mergeDonate = {
    ...(window.digitalData ? window.digitalData.donate : null),
    ...donate,
  };
  window.digitalData = {
    ...window.digitalData,
    donate: mergeDonate,
  };

  if (window._satellite && typeof window._satellite.track === "function") {
    window._satellite.track("donateFieldInteraction");
  }
};

/**
 * add page load to Adobe DTM logs
 * @param {string} tag
 * @param {string|null} target
 * @return {void}
 */
export const eventPageLoad = (tag, target = null) => {
  window.digitalData = {
    ...window.digitalData,
    page: {
      tag: tag,
      target: target,
    },
    eventInfo: {},
  };
  if (window._satellite && typeof window._satellite.track === "function") {
    window._satellite.track("page load");
  }
  // console.log("page load", window.digitalData);
};

/**
 * @param {string} name
 * @param {string} type
 * @return {void}
 */
export const eventFormStart = (name, type) => {
  if (typeof window.digitalData === "undefined") window.digitalData = {};
  if (typeof window.digitalData.event === "undefined") window.digitalData.event = [];
  window.digitalData.event.push({
    eventInfo: {
      eventName: "form start",
      type: type,
    },
    details: {
      name: name,
    },
  });
  if (window._satellite && typeof window._satellite.track === "function") {
    window._satellite.track("form_start");
  }
  // console.log("form start", window.digitalData);
};

/**
 *
 * @param {string} name
 * @param {string} type
 * @param {string} error
 * @return {void}
 */
export const eventFormError = (name, type, error) => {
  if (typeof window.digitalData === "undefined") window.digitalData = {};
  if (typeof window.digitalData.event === "undefined") window.digitalData.event = [];
  window.digitalData.event.push({
    eventInfo: {
      eventName: "form error",
      type: type,
    },
    details: {
      name: name,
      error: error,
    },
  });
  if (window._satellite && typeof window._satellite.track === "function") {
    window._satellite.track("form_error");
  }
  // console.log("form error", window.digitalData);
};

/**
 *
 * @param {string} message
 * @returns {Promise}
 */
const sha256 = async (message) => {
  // encode as UTF-8
  const msgBuffer = new TextEncoder().encode(message);

  // hash the message
  const hashBuffer = await crypto.subtle.digest("SHA-256", msgBuffer);

  // convert ArrayBuffer to Array
  const hashArray = Array.from(new Uint8Array(hashBuffer));

  // convert bytes to hex string
  const hashHex = hashArray.map((b) => b.toString(16).padStart(2, "0")).join("");
  return hashHex;
};

/**
 *
 * @param {string} name
 * @param {string} type
 * @param {string} email
 * @returns {Promise}
 */
export const eventFormComplete = async (name, type, email) => {
  if (typeof window.digitalData === "undefined") window.digitalData = {};
  if (typeof window.digitalData.event === "undefined") window.digitalData.event = [];
  const hash = await sha256(email);
  window.digitalData.event.push({
    eventInfo: {
      eventName: "form complete",
      type: type,
    },
    details: {
      name: name,
      id: hash,
    },
  });
  if (window._satellite && typeof window._satellite.track === "function") {
    window._satellite.track("form_complete");
  }
  // console.log("form complete", window.digitalData);
};

export const PROTECT_FIELD_VALUE = "****";
/**
 * @param {string} formName
 * @param {string} formType
 * @param {string} fieldName
 * @param {string|null} fieldValue
 * @return {void}
 */
export const eventFormFieldInteraction = (formName, formType, fieldName, fieldValue) => {
  if (typeof fieldValue === "undefined" || fieldValue === "" || fieldValue === null) return; //ignore empty value fields
  if (typeof window.digitalData === "undefined") window.digitalData = {};
  if (typeof window.digitalData.event === "undefined") window.digitalData.event = [];
  //fieldValue could PROTECT_FIELD_VALUE
  window.digitalData.event.push({
    eventInfo: {
      eventName: "form field interaction",
      type: formType,
    },
    details: {
      name: formName,
      field: fieldName,
      value: fieldValue,
    },
  });
  if (window._satellite && typeof window._satellite.track === "function") {
    window._satellite.track("form_field_interaction");
  }
  // console.log("form field interaction", window.digitalData);
};

/**
 * @param {string[]} amount
 * @return {void}
 */
export const eventViewPromotion = (amount, type = "") => {
  const prevPromotion = getWindow(WINDOW_KEYS.CACHE_VIEW_PROMOTION);
  const currPromotion = JSON.stringify(amount);
  if (prevPromotion?.has(currPromotion)) return; //if user have seen this promotion in this session, ignore it
  if (typeof window.digitalData === "undefined") window.digitalData = {};
  if (typeof window.digitalData.event === "undefined") window.digitalData.event = [];
  window.digitalData.event.push({
    eventInfo: {
      eventName: "ask amount shown " + type,
    },
    details: {
      askAmount: amount,
    },
  });

  //set the window cache for view promotion
  if (typeof prevPromotion === "undefined") setWindow(WINDOW_KEYS.CACHE_VIEW_PROMOTION, new Set([currPromotion]));
  else setWindow(WINDOW_KEYS.CACHE_VIEW_PROMOTION, prevPromotion.add(currPromotion));

  if (window._satellite && typeof window._satellite.track === "function") {
    window._satellite.track("view_promotion");
  }
  // console.log("view promotion", window.digitalData);
};

/**
 *
 * @param {string} amount
 * @param {string} type "once" | "monthly"
 */
export const eventSelectPromotion = (amount) => {
  if (typeof window.digitalData === "undefined") window.digitalData = {};
  if (typeof window.digitalData.event === "undefined") window.digitalData.event = [];
  window.digitalData.event.push({
    eventInfo: {
      eventName: "ask amount selected",
    },
    details: {
      askAmount: amount,
    },
  });
  if (window._satellite && typeof window._satellite.track === "function") {
    window._satellite.track("click_promotion");
  }
  // console.log("select promotion", window.digitalData);
};

/**
 *
 * @param {string} coverProcession "true" | "false"
 * @param {double} processingFee 5.00
 * @param {double} donationTotal 100.00
 * @param {string} patmentType "credit card" | "paypal" | "apple pay"
 * @param {string} email "user's email", we will hash it using sha256 in this function
 * @param {string} frequency "once" | "monthly"
 * @param {string} variant "individual" | "organisation"
 * @param {string|null} TransactionId transaction id got from card payment success
 */
export const eventPaymentSubmitted = async (coverProcession, processingFee, donationTotal, patmentType, email, frequency, variant) => {
  if (typeof window.digitalData === "undefined") window.digitalData = {};
  if (typeof window.digitalData.event === "undefined") window.digitalData.event = [];

  const mappingPaymentType = {
    [CREDIT_CARD_LABEL]: "credit card",
    [PAYPAL_LABEL]: "paypal",
    [APPLE_PAY_LABEL]: "apple pay",
  };

  const hash = await sha256(email);
  const data = {
    coverProcession: coverProcession,
    processingFee: processingFee,
    value: donationTotal,
    payment_type: mappingPaymentType[patmentType] ? mappingPaymentType[patmentType] : patmentType,
    frequency: frequency,
    variant: variant,
    id: hash,
  };

  window.digitalData.event.push({
    eventInfo: {
      eventName: "donationSubmitted",
    },
    details: data,
  });

  if (window._satellite && typeof window._satellite.track === "function") {
    window._satellite.track("donationSubmitted");
  }
};

/**
 *
 * @param {string} coverProcession "true" | "false"
 * @param {double} processingFee 5.00
 * @param {double} donationTotal 100.00
 * @param {string} patmentType "credit card" | "paypal" | "apple pay"
 * @param {string} email "user's email", we will hash it using sha256 in this function
 * @param {string} frequency "once" | "monthly"
 * @param {string} variant "individual" | "organisation"
 * @param {string|null} TransactionId transaction id got from card payment success
 */
export const eventPaymentStart = async (
  coverProcession,
  processingFee,
  donationTotal,
  patmentType,
  email,
  frequency,
  variant
) => {
  if (typeof window.digitalData === "undefined") window.digitalData = {};
  if (typeof window.digitalData.event === "undefined") window.digitalData.event = [];

  const hash = await sha256(email);
  const data = {
    coverProcession: coverProcession,
    processingFee: processingFee,
    value: donationTotal,
    payment_type: patmentType,
    frequency: frequency,
    variant: variant,
    id: hash,
  };

  window.digitalData.event.push({
    eventInfo: {
      eventName: "payment start",
    },
    details: data,
  });

  //always overwrite the session cache for payment start
  setSessionStorage(SESSION_STORAGE_KEYS.CACHE_PAYMENT_START, JSON.stringify(data));

  if (window._satellite && typeof window._satellite.track === "function") {
    window._satellite.track("payment_start");
  }

  // console.log("donation", window.digitalData);
};

/**
 * Applepay and Paypal success event
 * @param {*} transactionID
 * @returns
 */
export const eventPaymentSuccess = (transactionID = null) => {
  if (transactionID === null) return;
  const activePaymentStart = getSessionStorage(SESSION_STORAGE_KEYS.CACHE_PAYMENT_START);
  if (activePaymentStart === null) {
    console.log("skip donation tracking event as we didn't find an active paymentStart", activePaymentStart);
    return; //skip if we can't locate a payment start in session
  }

  if (typeof window.digitalData === "undefined") window.digitalData = {};
  if (typeof window.digitalData.event === "undefined") window.digitalData.event = [];

  //if user have done a payment start in the same session, we send a paypal success event
  const data = {
    ...JSON.parse(activePaymentStart),
    transactionID: transactionID,
  };

  window.digitalData.event.push({
    eventInfo: {
      eventName: "dontation",
    },
    details: data,
  });

  setSessionStorage(SESSION_STORAGE_KEYS.CACHE_PAYMENT_START, null); //clear session cache if we used a payment start

  if (window._satellite && typeof window._satellite.track === "function") {
    window._satellite.track("donation");
  }
  // console.log("donation", window.digitalData);
};

export const eventCardSuccess = (transactionID = null) => {
  if (transactionID === null) return;
  const activePaymentStart = getSessionStorage(SESSION_STORAGE_KEYS.CACHE_PAYMENT_START);

  if (activePaymentStart === null) {
    console.log("skip donation tracking event as we didn't find an active paymentStart", activePaymentStart);
    return; //skip if we can't locate a payment start in session
  }

  const data = {
    ...JSON.parse(activePaymentStart),
    transactionID: transactionID,
  };

  if (typeof window.digitalData === "undefined") window.digitalData = {};
  if (typeof window.digitalData.event === "undefined") window.digitalData.event = [];

  window.digitalData.event.push({
    eventInfo: {
      eventName: "dontation",
    },
    details: data,
  });

  setSessionStorage(SESSION_STORAGE_KEYS.CACHE_PAYMENT_START, null); //clear session cache if we used a payment start

  if (window._satellite && typeof window._satellite.track === "function") {
    window._satellite.track("donation");
  }

  // console.log("card success", window.digitalData);
};
